import React from 'react'
import BooksList from '../books/BooksList'
import { routeName } from '../../../../routes/routeName'
import { ELibraryCategory } from '../../enum/elibrary_enum'

type Props = {}

const JournalList = ({ }: Props) => {
    return (
        <BooksList
            category_label='วารสาร'
            category_path={routeName.e_library.journal}
            category_pathname_label={routeName.e_library.journal_list}
            library_category_name={ELibraryCategory.MAGAZINE}
            path_detail={routeName.e_library.journal_detail}
        />
    )
}

export default JournalList